var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.platFormTitle,
            visible: _vm.dialogFormVisible,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _vm.recordList && _vm.recordList.length
              ? _c(
                  "div",
                  { staticClass: "dialog-list" },
                  _vm._l(_vm.recordList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "dialog-item" },
                      [
                        _c("span", { staticClass: "dialog-value" }, [
                          _vm._v(_vm._s(item)),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "empty-text" }, [_vm._v("暂无记录")]),
          ]),
          _c(
            "div",
            { staticClass: "dialog-btn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleCloseClick },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }